<template>
  <!-- 账号登录/注册 -->
  <div class="login-content df fdc">
    <div class="f1">
      <div class="title df">
        <span class="active">{{ $t("账号登录/注册") }}</span>
      </div>
      <!-- 单选框手机号或者邮箱 -->
      <div class="phone-email mt-40">
        <el-radio-group v-model="propformdata.phoneEmail" @change="handlePhoneEmailChange">
          <el-radio label="phone">{{ $t("手机号") }}</el-radio>
          <el-radio label="email">{{ $t("邮箱") }}</el-radio>
        </el-radio-group>
      </div>

      <!-- 添加验证 -->
      <el-form :model="propformdata" :rules="rules" ref="form">
        <template v-if="propformdata.phoneEmail == 'phone'">
          <div class="df">
            <el-form-item prop="user_mobile_area_code" class="area-code-item">
              <div class="area-code df aic">
                <span class="iconfont icon-jia1"></span>
                <el-input v-model="propformdata.user_mobile_area_code" type="text" :min="0"
                  class="phone-input-item ml-4 mt-0" :placeholder="$t('请输入区号')" @input="validateInput" />
              </div>
            </el-form-item>
            <el-form-item prop="phone" class="phone-item f1">
              <!-- 手机号输入框 前面加上区号 -->
              <div class="phone-input df">
                <el-input v-model="propformdata.phone" class="phone-input-item ml-8" :placeholder="$t('请输入手机号')"
                  @input="validateInputPhone" />
              </div>
            </el-form-item>
          </div>

          <el-form-item prop="code_phone">
            <div class="code-input df">
              <el-input v-model="propformdata.code_phone" :placeholder="$t('请输入验证码')" />
              <el-button @click="handleGetCode" :disabled="showCodeTime" :class="{ disabled: showCodeTime }">{{
                showCodeTime
                  ? $t("重新发送") + " (" + codeTime + ")"
                  : $t("获取验证码")
              }}</el-button>
            </div>
          </el-form-item>
        </template>

        <template v-else>
          <!-- 邮箱 -->
          <el-form-item prop="email">
            <div class="phone-input">
              <el-input v-model="propformdata.email" class="phone-input-item" :placeholder="$t('请输入邮箱')" />
            </div>
          </el-form-item>

          <el-form-item prop="code_email">
            <div class="code-input df">
              <el-input v-model="propformdata.code_email" :placeholder="$t('请输入验证码')" />
              <el-button @click="handleGetCode" :disabled="emailshowCodeTime"
                :class="{ disabled: emailshowCodeTime }">{{
                  emailshowCodeTime
                    ? $t("重新发送") + " (" + emailcodeTime + ")"
                    : $t("获取验证码")
                }}</el-button>
            </div>
          </el-form-item>
        </template>

        <!-- 验证码输入框 -->
        <!-- <el-form-item prop="code">
        </el-form-item> -->
      </el-form>

      <!-- 密码登录提示 -->
      <div class="password-login">
        <el-button type="text" @click="handlePasswordLogin(2)">{{
          $t("密码登录")
        }}</el-button>
      </div>
    </div>
    <!-- 登录按钮 -->
    <div class="login-button">

      <el-button type="primary" @click="handleLogin" :loading="loading">{{
        $t("登录/注册")
      }}</el-button>
      <div class="mt-24 verify-box">
        <!-- 把这个多选变成圆形样式 -->
        <el-checkbox v-model="propformdata.privacy" class="checkbox-circle">{{
          $t("我已阅读并同意")
        }}</el-checkbox><span @click="handleDialogVisible('pri')"> {{ $t("隐私声明") }} </span>
        {{ $t("与") }}
        <span @click="handleDialogVisible('reg')">
          {{ $t("用户注册协议") }}</span>
      </div>
    </div>

    <!-- 弹框协议 -->
    <el-dialog :title="dialogTitle" :append-to-body="true" :z-index="2000" :visible.sync="dialogVisible">
      <div class="dialog-content">
        <div class="dialog-content-item" v-html="dialogContent"></div>
      </div>
    </el-dialog>

    <verify ref="verifyModal" @success="verifySuccess" />


  </div>
</template>

<script>
var this_ = this;
import verify from "./verify.vue";
import {
  getSmsCaptchaNew,
  getEmailCodeNew,
  user_first_edit,
  forgot,
  loginNew,
  userPriRegInfo,
} from "@api/user";
import { Alert } from "element-ui";
export default {
  components: {
    verify
  },
  data() {
    return {

      // 图形验证
      isNew: true,

      aes_key: 'ed8222',
      aes_script: '8NONwyJt',



      loading: false,
      // 协议弹框
      dialogVisible: false,
      // 弹框title
      dialogTitle: "",
      // 弹框内容
      dialogContent: "",
      propformdata: {
        phoneEmail: "phone", //选择手机还是邮箱
        user_mobile_area_code: 86, //手机区号
        phone: "", //手机号
        email: "", //邮箱
        code_phone: "", //验证码-手机
        code_email: "", //验证码-邮箱
        // 隐私声明
        privacy: true,
      },

      rules: {
        user_mobile_area_code: [
          { required: true, message: this.$t("请输入区号"), trigger: "blur" },
        ],
        phone: [
          { required: true, message: this.$t("请输入手机号"), trigger: "blur" },
          // {
          //   pattern: /^1[3-9]\d{9}$/,
          //   message: "请输入正确的手机号",
          //   trigger: "blur",
          // },
        ],
        email: [
          { required: true, message: this.$t("请输入邮箱"), trigger: "blur" },
          {
            pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: this.$t("请输入正确的邮箱"),
            trigger: "blur",
          },
        ],
        code_email: [
          { required: true, message: this.$t("请输入验证码"), trigger: "blur" },
        ],
        code_phone: [
          { required: true, message: this.$t("请输入验证码"), trigger: "blur" },
        ],
      },

      // 手机验证码倒计时
      codeTime: 60, //验证码倒计时
      showCodeTime: false, // 是否显示倒计时
      timer: null, // 定时器

      // 邮箱验证码倒计时
      emailcodeTime: 60, //验证码倒计时
      emailshowCodeTime: false, // 是否显示倒计时
      emailtimer: null, // 定时器
      // 获取当前语言
      language: this.$i18n.locale,
      callback: '',
    };
  },
  // 接收参数 formdata
  props: {
    formdata: {
      type: Object,
      default: () => {
        return {
          phoneEmail: "phone",
          user_mobile_area_code: "86",
          phone: "",
          email: "",
        };
      },
    },
  },
  // 监听参数 formdata
  watch: {
    formdata: {
      handler(newVal) {
        this.propformdata = newVal;
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    if (this.language == 'en') {
      this.propformdata.phoneEmail = 'email';
      this.propformdata.privacy=false;
    }
    this.getUserPriReg();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let registerType = urlParams.get("register_type");
    this.propformdata.register_source = urlParams.get("register_source");
    this.propformdata.tur_id = urlParams.get("tur_id");
    this.propformdata.tre_ep = urlParams.get("tre_ep");
    this.callback = urlParams.get("callback");
  },
  methods: {

    // 图形验证成功 !
    verifySuccess() {
      this.handleGetCode();
    },


    validateInput(value) {
      // 使用正则表达式验证输入内容
      const regex = /^[0-9]*$/; // 只允许输入数字
      if (!regex.test(value)) {
        // 如果输入的不是数字，去掉最后一个字符
        this.propformdata.user_mobile_area_code = value.replace(/[^0-9]/g, ""); // 替换非数字字符
      }
    },

    validateInputPhone(value) {
      // 使用正则表达式验证输入内容
      const regex = /^[0-9]*$/; // 只允许输入数字
      if (!regex.test(value)) {
        // 如果输入的不是数字，去掉最后一个字符
        this.propformdata.phone = value.replace(/[^0-9]/g, ""); // 替换非数字字符
      }
    },
    async getUserPriReg() {
      let res = await userPriRegInfo();
      this.priReg = res.data;
    },
    handlePasswordLogin(type) {
      this.$emit("handlePasswordLogin", type);
    },

    handleLogin() {
      var this_ = this;

      this.loading = true;
      this.$refs.form.validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this_.loading = false;
          }, 2000);
          this.$emit("handleLogin", this.propformdata);
        } else {
          setTimeout(() => {
            this_.loading = false;
          }, 50);
        }
      });
    },

    async handleGetCode() {

      var this_ = this;

      // 验证手机号
      if (this.propformdata.phoneEmail == "phone") {
        // 验证手机号是否为空
        if (!this.propformdata.phone) {
          this.$message.error(this.$t("请输入手机号"));
          return;
        }


        let phone = this.isNew ? this.$encryptByAES(this.propformdata.phone, this.aes_key, this.aes_script) : this.propformdata.phone;


        let codeRes = await getSmsCaptchaNew({
          phone: phone,
          px: "regis_",
          areacode: this.propformdata.user_mobile_area_code,
        });


        if (codeRes.status == '400C1' && this.isNew) {
          this.$refs.verifyModal.openModal(phone);
          return false;
        }


        if (codeRes.status == 200) {
          // 倒计时
          let time = 60;
          this.showCodeTime = true;
          this.timer = setInterval(() => {
            time--;
            this.codeTime = time;
            if (time <= 0) {
              
              clearInterval(this_.timer);
              this_.showCodeTime = false;
              this.codeTime=60;
            }
          }, 1000);
        }
        /**
         * 2025-4-10生成任意的验证到输入框
         * start
         */
        //2025-8-13关闭生成任意的验证到输入框
        // setTimeout(() => {
        //   this.propformdata.code_phone = Math.floor(Math.random() * 900000) + 100000;
        // }, 2000);
        /**
        * 2025-4-10生成任意的验证到输入框
        * end
        */
        // 验证手机号格式
        // const phoneRegex = /^1[3-9]\d{9}$/;
        // if (!phoneRegex.test(this.propformdata.phone)) {
        //   this.$message.error("请输入正确的手机号");
        //   return;
        // }
      }
      // 验证邮箱
      if (this.propformdata.phoneEmail == "email") {
        // 验证邮箱是否为空
        if (!this.propformdata.email) {
          this.$message.error(this.$t("请输入邮箱"));
          return;
        }
        // 验证邮箱格式
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.propformdata.email)) {
          this.$message.error(this.$t("请输入正确的邮箱"));
          return;
        }

        let codeRes = await getEmailCodeNew({
          email: this.propformdata.email,
          px: "regis_",
        });
        console.log(codeRes)
        if (codeRes.status == 200) {
          // 倒计时
          let time = 60;
          this.emailshowCodeTime = true;
          this.emailtimer = setInterval(() => {
            time--;
            this.emailcodeTime = time;
            if (time <= 0) {
              
              clearInterval(this_.emailtimer);
              this_.emailshowCodeTime = false;
              this.emailcodeTime=60;
            }
          }, 1000);
        }

      }

    },

    // 手机/邮箱切换
    handlePhoneEmailChange(val) {
      if(val=='email'){
        this.propformdata.privacy=false;
      }else{
        this.propformdata.privacy=true;
      }
      this.propformdata.user_mobile_area_code = '86';
      this.propformdata.phone = '';
      this.propformdata.email = '';
      this.$refs.form.resetFields(); // 重置表单字段
      // this.codeTime = 60;
      // this.showCodeTime = false;
      // clearInterval(this.timer);
    },

    // 弹框协议
    handleDialogVisible(type) {
      this.dialogVisible = true;
      if (type == "pri") {
        this.dialogTitle = this.priReg.privacyPro.tsap_title;
        this.dialogContent = this.priReg.privacyPro.tsap_content;
      } else {
        this.dialogTitle = this.priReg.registerPro.tsap_title;
        this.dialogContent = this.priReg.registerPro.tsap_content;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.area-code-item {
  width: 152px;
}

::v-deep() {
  .el-input__inner {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .phone-item .el-form-item__error {
    left: 6px;
  }

  .el-dialog__body {
    max-height: calc(70vh - 54px);
    margin-bottom: 24px;
    padding: 24px 0;

    .dialog-content {
      width: 100%;
      max-height: calc(70vh - 102px);
      padding: 0 24px;
      overflow: hidden;
      overflow-y: scroll;

      // 设置滚动条样式
      &::-webkit-scrollbar {
        width: 4px;
        height: 8px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #B7251E;
      }
    }
  }

  .el-form-item {
    margin-bottom: 0;
  }
}

.verify-box {
  font-size: 12px;
  line-height: 22px;
  color: #aeaeae;

  span {
    color: #b7251e;
    cursor: pointer;
  }
}

.checkbox-circle {
  ::v-deep() {
    .el-checkbox__inner {
      width: 19px;
      height: 19px;
      border-radius: 50%;
    }

    .el-checkbox__inner::after {
      width: 4px;
      left: 6px;
      top: 3px;
    }

    .el-checkbox__label {
      font-size: 12px;
      line-height: 22px;
      color: #aeaeae;
      padding-left: 6px;
    }
  }
}

::v-deep() {
  .el-form-item {
    margin-bottom: 0;
  }
}

* {
  font-family: "harmonyos";
  font-weight: 400;
}

::v-deep() {
  .el-radio__inner {
    width: 20px;
    height: 20px;
    border: 2px solid rgb(183, 37, 30) !important;
  }
}

.login-button {
  .el-button--primary {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
    padding: 0;
    background: rgb(183, 37, 30);
    color: rgb(255, 255, 255);
    font-size: 16px;
  }
}

.phone-input {
  .phone-input-item {
    height: 60px;
    border-radius: 8px;
    background: rgb(245, 248, 255);
    padding: 10px 16px;
    margin-top: 24px;

    ::v-deep() {
      .el-input--suffix .el-input__inner {
        border: none;
        background: transparent;
        padding-right: 0;

        color: rgb(179, 179, 179);

        font-size: 14px;
      }

      .el-input__inner {
        padding: 0;
        border: none;
        background: transparent;

        &::placeholder {
          color: rgb(179, 179, 179);
          font-size: 14px;
        }
      }

      .el-input__suffix {
        display: none;
      }
    }
  }
}

.password-login {
  margin-top: 24px;

  ::v-deep() {
    .el-button {
      color: rgb(183, 37, 30);
      font-size: 16px;
      margin-top: 24px;
      padding: 0;
      margin: 0;
    }
  }
}

.code-input,
.area-code {
  width: 400px;
  height: 60px;
  padding: 10px 16px 10px 16px;
  border-radius: 4px;
  background: rgb(245, 248, 255);
  margin-top: 24px;

  ::v-deep() {
    .el-button.disabled {
      color: #b3b3b3;
    }

    .el-input__inner {
      border: none;
      background: transparent;
      padding: 0;

      &::placeholder {
        color: rgb(179, 179, 179);
        font-size: 14px;
      }
    }

    .el-button {
      border: none;
      background: transparent;
      padding: 0;
      margin: 0;
      color: rgb(183, 37, 30);
      font-size: 14px;
    }
  }
}

.area-code {
  width: auto;

  // padding: 0 16px;
  span.iconfont {
    font-size: 14px;
    color: #000000;
  }

  ::v-deep(.phone-input-item) {
    padding: 10px 0;
  }
}

.login-container {
  width: 100%;
  height: 100%;
  position: relative;

  .login-content {
    width: 520px;
    height: 600px;
    min-height: 500px;
    max-height: 100vh;
    border-radius: 16px;
    box-shadow: 0px 8px 24px 8px rgba(28, 57, 123, 0.08);
    background: rgb(255, 255, 255);
    padding: 80px 60px;
    position: absolute;
    right: 120px;
    top: 50%;
    transform: translateY(-50%);
  }

  .title {
    font-size: 20px;
    line-height: 30px;
    color: rgb(25, 25, 25);

    span {
      font-size: 20px;
      line-height: 30px;
      position: relative;
    }

    span.active::after {
      content: "";
      display: inline-block;
      width: 100%;
      height: 2px;
      background: #b7251e;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
</style>